/*
 * File: UpdateCoursePolicy.ts
 * Author: Austin Robinson
 * Date Created: 10/8/2023
 * Copyright (c) DrivingDoc 2023
 */
import { createMutation } from 'react-query-kit';

import { PostGreSQLInterval, privateApi } from 'api';

export type UpdateCoursePolicyParams = {
  courseId: string;
  policy: {
    min_time_to_complete: PostGreSQLInterval | null;
    max_time_to_complete: PostGreSQLInterval | null;
    allow_self_service_extensions: boolean;
    standard_extension_time: PostGreSQLInterval | null;
    standard_extension_fee: number | null;
    max_extensions: number | null;
    max_time_to_request_extension: PostGreSQLInterval | null;
    absences_allowed_before_fee: number | null;
    absence_fee: number | null;
    absence_fee_due: PostGreSQLInterval | null;
    absence_fee_due_lock: boolean | null;
    no_permits_allowed_before_fee: number | null;
    no_permit_fee: number | null;
    no_permit_fee_due: PostGreSQLInterval | null;
    no_permit_fee_due_lock: boolean | null;
    allow_cancellations: boolean;
    cancellations_allowed_before_fee: number | null;
    cancellation_fee: number | null;
    cancellation_fee_due: PostGreSQLInterval | null;
    cancellation_fee_due_lock: boolean | null;
    late_cancellations_allowed_before_fee: number | null;
    late_cancellation_fee: number | null;
    late_cancellation_fee_due: PostGreSQLInterval | null;
    late_cancellation_fee_due_lock: boolean | null;
    late_cancellation_deadline: PostGreSQLInterval | null;
  };
};

export type UpdateCoursePolicyResult = boolean;

async function updateCoursePolicy(params: UpdateCoursePolicyParams): Promise<UpdateCoursePolicyResult> {
  // make api call
  const result = await privateApi.put(
    `${import.meta.env.VITE_API_BASE_URL}/courses/${params.courseId}/policy`,
    params.policy,
  );

  // return the data object
  return result.data;
}

const useUpdateCoursePolicy = createMutation({
  mutationFn: async (variables: UpdateCoursePolicyParams) => updateCoursePolicy(variables),
});

export { updateCoursePolicy, useUpdateCoursePolicy };
